import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "newsletter",
  "use": "newsletter-usage",
  "viewBox": "0 0 595.279 139",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 595.279 139\" id=\"newsletter\"><path d=\"M0 59.536h496.08C481.258 37.03 465.051 20.036 464.316 0c33.745 34.533 77.753 52.559 130.963 69.445a315.664 315.664 0 0 0-130.963 69.554c2.28-21.828 16.777-35.729 31.736-59.617H0V59.536z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./sv_cms/static/assets/images/icons/newsletter.svg
// module id = 300
// module chunks = 6